//检测对象是否为空
Object.isEmpty = obj => {
  return Object.keys(obj).length == 0;
};

window.$ = {
  //克隆对象
  clone: obj => {
    return JSON.parse(JSON.stringify(obj));
  },
  noop: () => { },
  //数组去重
  unique: arr => {
    const na = [];
    for (let i = 0; i < arr.length; i++) {
      if (na.indexOf(arr[i]) == -1) {
        na.push(arr[i]);
      }
    }
    return na;
  },
  //遍历数组
  each: (obj, callback) => {
    if (Array.isArray(obj)) {
      let length = obj.length;
      for (let i = 0; i < length; i++) {
        if (callback(i, obj[i]) === false) {
          break;
        }
      }
    } else {
      for (let i in obj) {
        if (obj.hasOwnProperty(i) && callback(i, obj[i]) === false) {
          break;
        }
      }
    }
    return obj;
  }
};



// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import App from './App'
import router from './router'

Vue.use(ElementUI)
Vue.config.productionTip = false




router.beforeEach((to, from, next) => {
  let t = window.localStorage.getItem('access-token');
  //需要登录权限的菜单
  if (to.meta.requireLogin && t == null) {
    router.replace({
      name: 'login'
    });
    return;
  }
  //登录状态禁止跳转到登录页
  if (t !== null && to.name == 'login') {
    router.replace({
      name: 'index'
    });
    return;
  }
  next();
});


/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js